// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2mZaW","header":"ReportDetails_header__TFQxM","title":"ReportDetails_title__2oKfR","left":"ReportDetails_left__3houj"};